<template>
	<div class="add">
		<el-dialog title="新增开票公司" :visible.sync="show1" width="600px" :before-close="onclose1">
			<div class="forms" v-if="show1">
				<el-form ref="ruleForm1" :model="ruleForm1" :rules="rules1" label-width="100px">
					<el-form-item label="公司名称" prop="name" >
						<el-input v-model="ruleForm1.name" placeholder="请输入公司名称"></el-input>
					</el-form-item>
					
					<el-form-item label="纳税识别号" prop="nssbh">
						<el-input v-model="ruleForm1.nssbh" placeholder="请输入纳税识别号"></el-input>
					</el-form-item>
					
					<el-form-item label="地址" prop="address">
						<el-input type="textarea" placeholder="请输入公司地址" v-model="ruleForm1.address" :rows="2">
						</el-input>
					</el-form-item>
		
					<el-form-item label="电话号码" prop="mobile">
						<el-input v-model="ruleForm1.mobile" placeholder="请输入电话号码"></el-input>
					</el-form-item>
		
					<el-form-item label="备注">
						<el-input type="textarea" placeholder="" v-model="ruleForm1.remark" maxlength="100" show-word-limit
							:rows="2">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose1">取消</el-button>
				<el-button type="primary" @click="onsub1()">确定</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog title="新增收款帐号" :visible.sync="show2" width="600px" :before-close="onclose2">
			<div class="forms" v-if="show2">
				<el-form ref="ruleForm2" :model="ruleForm2" :rules="rules2" label-width="100px">
					<el-form-item label="账号类型" prop="ctype">
						<el-radio-group v-model="ruleForm2.ctype" @change="onradio">
							<el-radio :label="1">对公银行账号</el-radio>
							<el-radio :label="2">个人银行账户</el-radio>
							<el-radio :label="3">个人支付宝账号</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="开票公司" prop="invoice_company" v-if="ruleForm2.ctype == 1" class="myformitem">
						<el-select v-model="ruleForm2.invoice_company" placeholder="请选择开票公司">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in kpgs"
								:key="k">
							</el-option>
						</el-select>
						<i class="i el-icon-circle-plus-outline" @click="onadd1()"></i>
					</el-form-item>
					<el-form-item label="姓名" prop="nickname" v-if="ruleForm2.ctype == 2 || ruleForm2.ctype == 3">
						<el-input v-model="ruleForm2.nickname" placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="开户银行" prop="khh" v-if="ruleForm2.ctype == 1 || ruleForm2.ctype == 2">
						<el-input v-model="ruleForm2.khh" placeholder="请输入开户行"></el-input>
					</el-form-item>
					<el-form-item label="账户" prop="account">
						<el-input v-model="ruleForm2.account" placeholder="请输入账户"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose2">取消</el-button>
				<el-button type="primary" @click="onsub2()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Add',
		data() {
			return {
				show1: false,
				ruleForm1: {
					id: 0,
					name: "",
					nssbh: "",
					address: "",
					mobile: "",
					remark: "",
				},
				rules1: {
					name: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}],
					nssbh: [{
						required: true,
						message: '请输入纳税识别号',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请输入电话号码',
						trigger: 'blur'
					}]
				},
				
				show2: false,
				kpgs: [],
				ruleForm2: {
					id: 0,
					ctype: 1,
					invoice_company: "",
					nickname: "",
					khh: "",
					account: ""
				},
				
				rules2: {
					ctype: [{
						required: true,
						message: '请选择账号类型',
						trigger: 'change'
					}],
					
					nickname: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					
					khh: [{
						required: true,
						message: '请输入开户行',
						trigger: 'blur'
					}],
					
					account: [{
						required: true,
						message: '请输入账户',
						trigger: 'blur'
					}],
					
					invoice_company: [{
						required: true,
						message: '请选择开票公司',
						trigger: 'change'
					}]
				},
				
			}
		},
		
		props: {
			type: { //用于回显
				type: Number,
				default: 1
			},
		},
		
		mounted() {
			this.onkpgs();
		},
		
		methods: {
			onclose1() {
				this.show1 = false;
				this.ruleForm1 = {
					id: 0,
					name: "",
					nssbh: "",
					address: "",
					mobile: "",
					remark: "",
				};
			},
			
			onsub1() {
				this.$refs['ruleForm1'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm1));
						this.$axios.post('api/user/user_invoice_company_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose1();
								if(this.type == 1) {
									this.onkpgs();
								} else {
									this.$emit('upadd','');
								}
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onkpgs() {
				var obj = {};
				obj.page = 1;
				obj.limit = 1000;
				
				this.$axios.post('api/user/user_invoice_company_list', obj).then(res => {
					if (res.data.code == 0) {
						this.kpgs = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onclose2() {
				this.show2 = false;
				this.ruleForm2 = {
					id: 0,
					ctype: 1,
					invoice_company: "",
					nickname: "",
					khh: "",
					account: ""
				};
			},
			
			onradio() {
				this.ruleForm2.invoice_company = "";
				this.ruleForm2.nickname = "";
				this.ruleForm2.khh = "";
				this.ruleForm2.account = "";
			},
			
			onsub2() {
				this.$refs['ruleForm2'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm2));
						this.$axios.post('api/user/user_bank_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose2();
								this.$emit('upadd','');
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onadd1() {
				this.show1 = true;
			}
		}
	}
</script>

<style scoped lang="less">
	.add {
		
	}
	
	/deep/ .el-select {
		width: 400px;
	}
	
	/deep/ .el-input {
		width: 400px;
	}
	
	/deep/ .el-textarea {
		width: 400px;
	}
</style>


// WEBPACK FOOTER //
// src/common/add.vue